var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"btn btn__text",attrs:{"color":"#FFF"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" Ver Canales ")])
}
var staticRenderFns = []

export { render, staticRenderFns }